import clsx from 'clsx';

export default function Spinner({className}) {
    return (
        <svg 
        class={clsx('animate-spin', className)}
        xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
        >
            <path
                d="m1,12C1,5.92,5.92,1,12,1"
                fill="none"
                stroke="currentColor"
                stroke-miterlimit="10"
                stroke-width="2"
                stroke-linecap="round"
            />
        </svg>
    );
}